module.exports = __webpack_public_path__ + "static/img/not_qx.f8420fbe.png";